<i class="{{icon}}" [style]="sizeRem"></i>



